import { gql } from '@apollo/client';

import { AppMembershipFragment } from './appMemberships.fragment';

export * from './appMemberships.query.generated';

export const APP_MEMBERSHIPS = gql`
  ${AppMembershipFragment}
  query appMemberships(
    $appId: ID!
    $page: Int
    $perPage: Int
    $query: String
    $orderBy: AppMembershipsOrderByEnum
    $order: QueryOrderEnum
  ) {
    appMemberships(appId: $appId, page: $page, perPage: $perPage, query: $query, orderBy: $orderBy, order: $order) {
      nodesCount
      pagesCount
      nodes {
        ...AppMembershipFragment
      }
      hasNextPage
      hasPreviousPage
    }
  }
`;
